import { render, staticRenderFns } from "./ParentProductCombobox.vue?vue&type=template&id=4c098488&scoped=true&"
import script from "./ParentProductCombobox.vue?vue&type=script&lang=ts&"
export * from "./ParentProductCombobox.vue?vue&type=script&lang=ts&"
import style0 from "./ParentProductCombobox.vue?vue&type=style&index=0&id=4c098488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c098488",
  null
  
)

export default component.exports